import * as ajax from './ajax'

export const delay = (ms: number) => new Promise((r) => setTimeout(r, ms))

export const getVideos = async () => {
  let welcome, videos, sections

  await ajax.get("/video/list").then(result => {
    videos = result.data.VideoNewGroup
    welcome = result.data.welcome
  }).catch(e => {
    console.log(e)
    alert("Error, please try again [7]")
  })
  await ajax.get("/video/sections").then(result => {
    sections = result.data
  }).catch(err => {
    console.log(err)
  })

  return { videos, welcome, sections }
}

export const tags = async () => {
  const tags = await ajax.get("/video/tags").then(result => result.data).catch(err => console.log(err))
  return tags
}

export const sections = async () => {
  const sections = await ajax.get("/video/sections").then(result => result.data).catch(err => console.log(err))
  return sections
}

export const company = async () => {
  const company = await ajax.get("/video/company").then(result => result.data).catch(err => console.log(err))
  return company.sort((a, b) => a.company > b.company ? 1 : -1)
}

export const videoNumberOfView = async (id) => {
  const view = await ajax.get("/video/video_View?id=" + id).then(result => result.data).catch(err => console.log(err))
  return view
}

export const library = async () => {
  const view = await ajax.get("/report/library").then(result => result.data).catch(err => console.log(err))
  return view
}